import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '01',
    text: 'Descarga el eBook y revisa tu Lista de Compras chilena.'
  }, {
    num: '02',
    text: 'Aplica el Protocolo de Reset de 72 horas para encender tu metabolismo.'
  }, {
    num: '03',
    text: 'Sigue las recetas de 15 minutos y nota cómo tu ropa empieza a quedarte holgada de nuevo.'
  }];
  return <section className="py-14 md:py-16 bg-brand-navy text-white" data-id="element-144">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-145">
        <div className="text-center mb-16" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-cream" data-id="element-147">
            ¿Cómo funciona?
          </h2>
          <p className="text-brand-gold mt-4 font-medium" data-id="element-148">
            Tres pasos simples para recuperar tu bienestar
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-149">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-gold/20 z-0" data-id="element-150"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-151">
              <div className="w-24 h-24 rounded-full bg-brand-navy border-4 border-brand-gold flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(212,164,55,0.2)]" data-id="element-152">
                <span className="text-3xl font-serif font-bold text-brand-gold" data-id="element-153">
                  {step.num}
                </span>
              </div>
              <p className="text-lg text-brand-cream/90 leading-relaxed px-4" data-id="element-154">
                {step.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}